export const EMPTY_STATE_TYPE = {
  FIRST_TIME_IN_APP: 'FIRST_TIME_IN_APP',
  NO_RESULTS_IN_FOLDER: 'NO_RESULTS_IN_FOLDER',
  NO_RESULTS_WITH_FILTER_APPLIED: 'NO_RESULTS_WITH_FILTER_APPLIED'
};